import React from 'react';
import { DropdownSelect } from '@prezi/bento';
import { createDataLookup } from '../../const';
const DocumentAccessSelect = ({
  accessOptions,
  currentAccessValue
}) => {
  const [value, setValue] = React.useState(currentAccessValue);
  const handler = value => {
    setValue(value);
  };
  return React.createElement(DropdownSelect, {
    value: value,
    options: accessOptions,
    disabled: false,
    onChange: handler,
    dataLookup: createDataLookup('document-access-selector')
  });
};
export default DocumentAccessSelect;